<script setup lang="ts">
export interface IconTshirt {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconTshirt>(), { fill: "#A9B7D1", width: 18, height: 18 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable-next-line max-len -->
    <path d="M15.94 7.17 18 5.136s-1.99-2.37-3.715-3.253C13.382 1.42 11.838 1 11.838 1a2.81 2.81 0 0 1-.996 1.642 2.923 2.923 0 0 1-1.836.645c-.67 0-1.32-.228-1.836-.645A2.81 2.81 0 0 1 6.175 1s-1.548.408-2.452.866C1.988 2.746 0 5.136 0 5.136l1.674 1.66 1.505 1.541v7.012c0 .912.755 1.651 1.687 1.651h8.268c.932 0 1.687-.739 1.687-1.65V8.32l1.119-1.15z" :fill="props.fill" fill-rule="nonzero" />
  </svg>
</template>
